import React from 'react'
import styles from './head-title.styles'
import injectSheet from 'react-jss'
import classNames from 'classnames'

const HeadTitle = ({ classes, children, className }) => (
  <h2 className={classNames(classes.title, className)}>{children}</h2>
)

export default injectSheet(styles)(HeadTitle)
